export const EMPLOYEE_REVIEWS_ENDPOINT = `${process.env.REACT_APP_API_URL}/api/vault77/employeeReviews`;
